<template>
  <v-card class="credits-overview-dialog" flat>
    <div v-if="is_mobile" class="d-flex mt-n4 mr-n4">
      <v-btn
        icon
        dark
        variant="text"
        class="ml-auto"
        @click="$emit('close-dialog')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-btn
      v-if="!is_mobile"
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="d-flex flex-column ga-8">
      <div class="">
        <h1>{{ $t("jouw-creditoverzicht") }}</h1>
        <p class="mt-2">
          {{
            $t(
              "bekijk-hier-hoeveel-credits-je-al-hebt-gebruikt-en-wat-je-nog-over-hebt"
            )
          }}
        </p>
      </div>

      <component :is="currentPeriodComponent" :max="max" />
    </div>
  </v-card>
</template>

<script>
import DailyOverview from "./credit-overviews/daily-overview.vue";
import WeeklyOverview from "./credit-overviews/weekly-overview.vue";
import MonthlyOverview from "./credit-overviews/monthly-overview.vue";
import YearlyOverview from "./credit-overviews/yearly-overview.vue";

import { useMainStore } from "../../stores/store";
import isMobile from "@/mixins/isMobile";

export default {
  mixins: [isMobile],
  components: {
    DailyOverview,
    WeeklyOverview,
    MonthlyOverview,
    YearlyOverview,
  },
  data() {
    return {
      max: 0,
      period: null,
      mainStore: useMainStore(),
    };
  },

  mounted() {
    this.period = this.mainStore.companypage.settings.period;
    this.max = this.mainStore.companypage.settings.credits;
  },

  computed: {
    currentPeriodComponent() {
      switch (this.period) {
        case "day":
          return DailyOverview;
        case "week":
          return WeeklyOverview;
        case "month":
          return MonthlyOverview;
        case "year":
          return YearlyOverview;
        default:
          // dont return anything if no period is set
          return null;
      }
    },
  },
};
</script>
